/**
 * @deprecated
 */
import $ from 'jquery';



/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web.js